(function (global) {
  'use strict';

  function id(value) { return String(value || '').split('/').pop(); }
  function plain(value) {
    var text = String(value || '').replace(/<[^>]*>/g, '').trim();
    return /\{\{|VARIABLE_NOT_SET/.test(text) ? '' : text;
  }
  function resolvePreorder(data, variantId, templates) {
    var variant = data && data.product && data.product.variants && data.product.variants[id(variantId)];
    if (!variant || !variant.config || variant.config.status !== 'ACTIVE' || variant.isPOEnabled === false) return null;
    var defaultTemplate = data.settings && data.settings.templates && data.settings.templates.PO;
    var template = (templates || {})[variant.config.settingsTemplate || defaultTemplate] || (templates || {})[defaultTemplate] || {};
    var cart = template.cart && template.cart.labelText || {};
    var custom = variant.settings && variant.settings.type === 'CUSTOM' ? variant.settings : {};
    return {
      propertyKey: plain(custom.cartLabelTextKey || cart.key) || 'Pre-order item',
      message: plain(custom.cartLabelTextValue || cart.value) || 'Delivers as soon as available',
    };
  }
  function collectionNotice(data, templates) {
    var variants = data && data.product && data.product.variants || {};
    var variantIds = Object.keys(variants);
    if (variantIds.length === 1) return resolvePreorder(data, variantIds[0], templates);
    return variantIds.some(function (variantId) { return resolvePreorder(data, variantId, templates); })
      ? { label: 'Pre-order in select sizes', message: '' } : null;
  }

  function decorateBundle(form, items, statuses, shippingMessage) {
    if (!form || typeof form.entries !== 'function') return;
    var entries = Array.from(form.entries());
    var first = entries.find(function (entry) { return /^items\[\d+\]\[properties\]\[_bundly__bundle_id\]$/.test(entry[0]); });
    if (!first) return;
    var prefix = first[0].replace(/\[properties\].*$/, '[properties]');
    var delayed = false;
    entries.forEach(function (entry) {
      var match = entry[0].match(/^items\[(\d+)\]\[id\]$/);
      if (!match) return;
      var variantId = id(entry[1]);
      var status = statuses.get(variantId);
      if (!status) return;
      form.set('items[' + match[1] + '][properties][' + status.propertyKey + ']', status.message);
      form.set(prefix + '[_message_bundle_preorder_' + variantId + ']', status.message);
      delayed = true;
    });
    if (!delayed) return;
    form.set(prefix + '[Bundle shipping]', shippingMessage);
  }

  function createLoader(fetchJson) {
    var products = new Map();
    var templates;
    return function (productId) {
      productId = id(productId);
      if (!products.has(productId)) {
        if (!templates) templates = fetchJson('/apps/timesact/shop/settings').then(function (data) {
          return data && data.settings || {};
        }).catch(function (error) { templates = null; throw error; });
        var request = Promise.all([fetchJson('/apps/timesact/config?productId=' + encodeURIComponent(productId)), templates])
          .then(function (results) { return { config: results[0], templates: results[1] }; })
          .catch(function (error) { products.delete(productId); throw error; });
        products.set(productId, request);
      }
      return products.get(productId);
    };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { resolvePreorder: resolvePreorder, collectionNotice: collectionNotice, decorateBundle: decorateBundle, createLoader: createLoader };
  }
  if (!global || !global.document) return;
  var document = global.document;
  var configNode = document.querySelector('[data-message-bundle-preorders]');
  if (!configNode) return;
  var shippingMessage;
  try {
    var policy = JSON.parse(configNode.textContent);
    if (policy.stockOnly === true) return;
    shippingMessage = policy.shippingMessage;
  } catch (_) { return; }
  var productData = new Map();
  var variantProducts = new Map();
  var loading = new Set();
  var observer;
  var observedRoot;
  var scheduled = false;
  var submitting = false;

  var load = createLoader(function (url) {
    var controller = new AbortController();
    var timeout = global.setTimeout(function () { controller.abort(); }, 10000);
    return global.fetch(url, { credentials: 'same-origin', signal: controller.signal }).then(function (response) {
      if (response.status === 404 && url.indexOf('/config?') !== -1) return null;
      if (!response.ok) throw new Error('Shipping lookup failed');
      return response.json();
    }).finally(function () { global.clearTimeout(timeout); });
  });

  function loadProduct(productId) {
    productId = id(productId);
    return load(productId).then(function (data) {
      productData.set(productId, data);
      var variants = data.config && data.config.product && data.config.product.variants || {};
      Object.keys(variants).forEach(function (variantId) { variantProducts.set(id(variantId), productId); });
      return data;
    });
  }
  function statusFor(variantId, productId) {
    var data = productData.get(id(productId || variantProducts.get(id(variantId))));
    return data ? resolvePreorder(data.config, variantId, data.templates) : null;
  }
  function setText(node, value) { if (node.textContent !== value) node.textContent = value; }
  function notice(host, status, before) {
    var node = host.querySelector(':scope > .message-bundly-preorder');
    if (!status) { if (node) node.remove(); return; }
    if (!node) {
      node = document.createElement('div');
      node.className = 'message-bundly-preorder';
      node.setAttribute('data-item', 'small-text');
      var label = document.createElement('span');
      label.className = 'message-bundly-preorder-label';
      node.appendChild(label);
      var message = document.createElement('span');
      message.className = 'message-bundly-preorder-message';
      node.appendChild(message);
      host.insertBefore(node, before || null);
    }
    setText(node.querySelector('.message-bundly-preorder-label'), status.label || 'Pre-order');
    setText(node.querySelector('.message-bundly-preorder-message'), status.message || '');
  }
  function summary(root, message, error) {
    var buy = root.querySelector('bundly-buy-buttons');
    if (!buy) return;
    var node = root.querySelector('.message-bundly-preorder-summary');
    if (!message) { if (node) node.remove(); return; }
    if (!node) {
      node = document.createElement('p');
      node.className = 'message-bundly-preorder-summary';
      node.setAttribute('aria-live', 'polite');
      buy.parentElement.insertBefore(node, buy);
    }
    node.setAttribute('role', error ? 'alert' : 'note');
    setText(node, message);
  }
  function selectedIds(root) {
    return Array.from(new Set(Array.from(root.querySelectorAll('bundly-slot[data-variant-id]'))
      .map(function (slot) { return id(slot.getAttribute('data-variant-id')); }).filter(Boolean))).sort().join(',');
  }
  function refresh() {
    var root = document.querySelector('.bundly__block.message-bundly-compact');
    if (!root) return;
    if (root !== observedRoot) {
      if (observer) observer.disconnect();
      observedRoot = root;
      observer = new MutationObserver(schedule);
      observer.observe(root, { subtree: true, childList: true, attributes: true,
        attributeFilter: ['data-selected-variant-id', 'data-variant-id', 'data-product-id', 'data-open'] });
    }
    var slots = Array.from(root.querySelectorAll('bundly-slot[data-variant-id]'));
    root.querySelectorAll('bundly-collection-component-card[data-product-id], bundly-product-component-card[data-product-id]').forEach(function (card) {
      var productId = id(card.getAttribute('data-product-id'));
      if (!productData.has(productId) && !loading.has(productId)) {
        loading.add(productId);
        loadProduct(productId).catch(function () {}).finally(function () { loading.delete(productId); });
        // Only a completed successful lookup schedules another render; failures retry on submission.
        load(productId).then(schedule, function () {});
      }
      var data = productData.get(productId);
      if (!data) return;
      var chosen = card.getAttribute('data-selected-variant-id') || (slots.find(function (slot) {
        return variantProducts.get(id(slot.getAttribute('data-variant-id'))) === productId;
      }) || { getAttribute: function () { return ''; } }).getAttribute('data-variant-id');
      var status = chosen ? statusFor(chosen, productId) : null;
      if (!chosen && card.localName === 'bundly-collection-component-card') {
        status = collectionNotice(data.config, data.templates);
      }
      var info = card.querySelector('.bundly__component_info');
      if (info) notice(info, status);
    });
    root.querySelectorAll('.bundly__product_modal .bundly__add_to_bundle_button[data-variant-id][data-product-id]').forEach(function (button) {
      notice(button.parentElement, statusFor(button.getAttribute('data-variant-id'), button.getAttribute('data-product-id')), button);
    });
    var delayed = false;
    slots.forEach(function (slot) {
      var status = statusFor(slot.getAttribute('data-variant-id'));
      var title = slot.querySelector('.bundly__slot_title');
      if (title) notice(title, status);
      delayed = delayed || Boolean(status);
    });
    if (!submitting && !root.hasAttribute('data-message-preorder-error')) summary(root, delayed ? shippingMessage : '');
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    global.requestAnimationFrame(function () { scheduled = false; refresh(); });
  }
  ['bundly:afterLoadBundle', 'bundly:afterAddVariant', 'bundly:afterRemoveVariant',
    'bundly:afterChangeVariantOption', 'bundly:afterToggleProductDialog', 'bundly:afterUpdateBlock'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var detail = event.detail || {};
      if (detail.variantId && detail.productId) variantProducts.set(id(detail.variantId), id(detail.productId));
      var root = observedRoot;
      if (root) root.removeAttribute('data-message-preorder-error');
      schedule();
    });
  });
  document.addEventListener('bundly:beforeAddBundleToCart', function (event) {
    if (event.defaultPrevented) return;
    var detail = event.detail || {};
    var source = detail.sourceElement || event.target;
    var root = source && source.closest && source.closest('.message-bundly-compact');
    if (!root || !detail.formData || !Array.isArray(detail.bundleItems)) return;
    var items = detail.bundleItems;
    if (submitting) { event.preventDefault(); return; }
    if (items.every(function (item) { return productData.has(id(item.productId)); })) {
      var statuses = new Map();
      items.forEach(function (item) {
        var status = statusFor(item.variantId, item.productId);
        if (status) statuses.set(id(item.variantId), status);
      });
      decorateBundle(detail.formData, items, statuses, shippingMessage);
      return;
    }
    event.preventDefault();
    submitting = true;
    root.removeAttribute('data-message-preorder-error');
    source.setAttribute('aria-busy', 'true');
    summary(root, 'Checking shipping availability…');
    var selection = selectedIds(root);
    Promise.all(items.map(function (item) { return loadProduct(item.productId); })).then(function () {
      submitting = false;
      source.removeAttribute('aria-busy');
      refresh();
      var button = source.querySelector('.bundly__add_to_cart_button');
      if (source.isConnected && selectedIds(root) === selection && button && !button.disabled) button.click();
    }).catch(function () {
      submitting = false;
      source.removeAttribute('aria-busy');
      root.setAttribute('data-message-preorder-error', '');
      summary(root, 'We couldn’t check shipping availability. Please try again.', true);
    });
  });
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('shopify:section:load', schedule);
  var discovery = new MutationObserver(function () {
    if (document.querySelector('.message-bundly-compact')) { discovery.disconnect(); schedule(); }
  });
  discovery.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  schedule();
})(typeof window === 'undefined' ? null : window);
